import { Stack, styled } from '@mui/material';

import { getBorder } from '@/theme/utils';

const Container = styled(Stack)(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  borderBottom: getBorder(theme.palette.border.default),
}));

export { Container };
